import { safeLazy } from '../utils/SafeLazy/SafeLazy'
import ChunkLoader from '../components/ChunkLoader/ChunkLoader'

export const DASHBOARD_PATH = '/dashboard'

const DashboardPage = safeLazy(() => import('../pages/Dashboard/DashboardPage'))

export const DASHBOARD_ROUTES = [
	{
		path: DASHBOARD_PATH,
		element: (
			<ChunkLoader>
				<DashboardPage />
			</ChunkLoader>
		),
	},
]
